/*
 * - Definitions for Aquatic Resources mutations
 */
import AquaticResourceService from './service';
import {
  AddAquaticResourceResponse,
  DeleteAquaticResourceRequest,
  DeleteAquaticResourceResponse,
  GetAquaticResourceRequest,
  UpdateAquaticResourceResponse,
} from './types';

export class AquaticResourcesMutations {
  public static readonly addAquaticResources = async (
    payload: GetAquaticResourceRequest
  ): Promise<AddAquaticResourceResponse> => {
    const response = await AquaticResourceService.addAquaticResources(payload);

    return response;
  };
  public static readonly updateAquaticResources = async (
    payload: GetAquaticResourceRequest
  ): Promise<UpdateAquaticResourceResponse> => {
    const response = await AquaticResourceService.updateAquaticResources(payload);

    return response;
  };
  public static readonly deleteAquaticResources = async (
    payload: DeleteAquaticResourceRequest
  ): Promise<DeleteAquaticResourceResponse> => {
    const response = await AquaticResourceService.deleteAquaticResources(payload);

    return response;
  };
  public static readonly deleteAllAquaticResources = async (
    payload: DeleteAquaticResourceRequest
  ): Promise<DeleteAquaticResourceResponse> => {
    const response = await AquaticResourceService.deleteAquaticResources(payload);

    return response;
  };
}
